<template>
    <div>
        <see-user-profile/>
    </div>
</template>

<script>
import SeeUserProfile from '../../components/Users/SeeUserProfile.vue'
export default {
  components: { SeeUserProfile },
    
}
</script>